import { lazy } from 'react'

export const WeightGainResult = lazy(() => import('./WeightGainResult'))
